import { requestApi } from "@/api/core";
import { dynamicDispatcher } from "@/libs/util";

export const getStatisticByProjectId = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Column/GetStatisticByProjectId",
      method: "POST",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getTransferLogByTaskId = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Column/GetTransferLogByTaskId",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getColumnListByTaskId = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Column/GetColumnListByTaskId",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getUserInColumn = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Column/GetUserInColumn",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const beforeUndo = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Column/BeforeUndo",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const undoTask = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Column/Undo",
      method: "GET",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};
